export function getNestedValue(obj: any, path: string): any {
    if (!obj || !path) return null;
    return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function setNestedValue(obj: any, path: string, value: any): void {
    if (!obj || !path) return;

    const parts = path.split('.');
    const last = parts.pop();
    const target = parts.reduce((acc, key) => {
        if (typeof acc[key] !== 'object' || acc[key] === null) acc[key] = {};
        return acc[key];
    }, obj);

    if (last) target[last] = value;
}

export function unflattenObject(flat: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {};

    Object.entries(flat).forEach(([key, value]) => {
        const parts = key.split('.');
        const last = parts.pop()!;
        const target = parts.reduce((acc, part) => {
            if (!acc[part] || typeof acc[part] !== 'object') {
                acc[part] = {};
            }
            return acc[part];
        }, result);

        target[last] = value;
    });

    return result;
}
